import React from 'react';
import {
  StyleSheet,
  View,
  Text,
  ScrollView,
} from './components/base_components';
import Link from './components/link';
import ProgressSpinner from './components/progress_spinner';
import Header from './components/header';

import DeviceStore from './stores/device_store';
import UserStore from './stores/user_store';
import VolumeStore from './stores/volume_store';

const LOGO_IMG = require('./assets/img/logo.png');

const styles = StyleSheet.create({
  homeScreen: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'transparent',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  scroller: {
    flex: 1,
    alignSelf: 'stretch',
    flexDirection: 'column',
  },
  scrollInner: {
    paddingLeft: '3em',
    paddingRight: '3em',
    paddingTop: '1em',
    paddingBottom: '5em',
    alignSelf: 'stretch',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    overflowY: 'scroll',
  },
  top: {
    alignSelf: 'stretch',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  fill: {
    flex: 1,
  },
  logo: {
    width: '8em',
    height: '8em',
    marginRight: '1em',
  },
  line: {
    alignSelf: 'stretch',
    height: '1px',
    backgroundColor: 'black',
  },
  headerText: {
    color: '#444',
    fontSize: '1.4em',
    fontWeight: 'bold',
  },
  list: {
    marginTop: '1em',
    marginBottom: '1em',
  },
  add: {
    marginTop: '1em',
  },
  spacer: {
    height: '1em',
  },
  volume: {
    marginTop: '1em',
  },
  volumeName: {},
  sectionText: {
    marginTop: '0.5em',
    fontSize: '1.5em',
  },
  device: {
    marginTop: '1em',
  },
});

type Props = {};
type State = {
  is_admin: boolean;
  device_list: [any] | null;
  volume_list: [any] | null;
  current_org_id: number;
};

export default class HomeScreen extends React.PureComponent<Props, State> {
  state = {
    is_admin: UserStore.getUser().is_admin,
    device_list: null,
    volume_list: null,
    current_org_id: UserStore.getCurrentOrgId(),
  };
  componentDidMount() {
    UserStore.addChangeListener(this._onUserUpdate);
    VolumeStore.addChangeListener(this._onVolumeUpdate);
    DeviceStore.addChangeListener(this._onDeviceUpdate);
    VolumeStore.fetch();
    DeviceStore.fetch();
    this._onVolumeUpdate();
    this._onDeviceUpdate();
  }
  componentWillUnmount() {
    VolumeStore.removeChangeListener(this._onVolumeUpdate);
    DeviceStore.removeChangeListener(this._onDeviceUpdate);
  }
  _onVolumeUpdate = () => {
    const volume_list = VolumeStore.getList();
    this.setState({ volume_list });
  };
  _onDeviceUpdate = () => {
    const device_list = DeviceStore.getList();
    this.setState({ device_list });
  };
  _onUserUpdate = () => {
    const current_org_id = UserStore.getCurrentOrgId();
    this.setState({ current_org_id });
  };

  render() {
    const { current_org_id, volume_list, device_list, is_admin } = this.state;
    let overlay = null;

    let admin_section = null;
    if (is_admin) {
      admin_section = (
        <>
          <Text style={styles.headerText}>Admin Stuff</Text>
          <Link href='/admin/org' text='Orgs' />
          <Link href='/tool' text='Tools' />
          <Link href='/admin/client_version' text='Client Versions' />
          <Link href='/admin/file_report' text='Project Drive Usage Report' />
        </>
      );
    }
    let volumes = null;
    if (!volume_list) {
      volumes = <ProgressSpinner />;
    } else if (volume_list.length === 0) {
      volumes = <Text style={styles.noVolumes}>No volumes</Text>;
    } else {
      const filtered_list = volume_list.filter(
        (v) => v.org_id === current_org_id && !v.is_disabled
      );
      volumes = filtered_list.map((v, i) => <Volume key={i} volume={v} />);
    }

    let devices = null;
    if (!device_list) {
      devices = <ProgressSpinner />;
    } else if (device_list.length === 0) {
      devices = <Text style={styles.noVolumes}>No devices</Text>;
    } else {
      const filtered_list = device_list.filter(
        (d) => d.org_id === current_org_id && !d.is_disabled
      );
      devices = filtered_list.map((d, i) => <Device key={i} device={d} />);
    }

    return (
      <View style={styles.homeScreen}>
        <ScrollView
          style={styles.scroller}
          contentContainerStyle={styles.scrollInner}
        >
          <Header />
          <Text style={styles.sectionText}>Volumes</Text>
          {volumes}
          <View style={styles.spacer} />
          <Line />
          <Text style={styles.sectionText}>Devices</Text>
          {devices}
          <View style={styles.spacer} />
          <Line />
          <View style={styles.spacer} />
          {admin_section}
        </ScrollView>
        {overlay}
      </View>
    );
  }
}

function Line() {
  return <View style={styles.line} />;
}

function Volume(props) {
  const { volume } = props;
  const { volume_id, volume_name } = volume;
  const href = `/volume/${volume_id}`;
  return (
    <View style={styles.volume}>
      <Link href={href} text={volume_name} />
    </View>
  );
}

function Device(props) {
  const { device } = props;
  const { device_id, device_name } = device;
  const href = `/device/${device_id}`;
  return (
    <View style={styles.device}>
      <Link href={href} text={device_name} />
    </View>
  );
}
